import { DateIntervalFields } from '@mews-commander/form';
import { Stack } from '@optimus-web/core';

interface DateRangeFilterProps {
    startDateName: string;
    startDateLabel: React.ReactNode;
    endDateName: string;
    endDateLabel: React.ReactNode;
}
export const DateRangeFilter = ({ startDateName, startDateLabel, endDateName, endDateLabel }: DateRangeFilterProps) => (
    <Stack spacing="200">
        <DateIntervalFields
            startDateProps={{
                name: startDateName,
                label: startDateLabel,
            }}
            endDateProps={{
                name: endDateName,
                label: endDateLabel,
            }}
            mode="iso"
        />
    </Stack>
);
